import { render, staticRenderFns } from "./ShipmentsPrintbar.vue?vue&type=template&id=641bd685"
import script from "./ShipmentsPrintbar.vue?vue&type=script&lang=js"
export * from "./ShipmentsPrintbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports